import React, { useState, useEffect, useRef } from "react";
import { useController } from "react-hook-form";

const MemberSearchSelect = ({
  name,
  control,
  register,
  options = [],
  label,
  errors,
  errortext,
}) => {
  const {
    field: { onChange, value },
  } = useController({ name, control });

  const [search, setSearch] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    if (search) {
      const filteredOptions = options.filter((opt) =>
        opt.email.toLowerCase().includes(search.toLowerCase())
      );
      setFiltered(filteredOptions);
      setShowDropdown(true);
    } else {
      setFiltered([]);
      setShowDropdown(false);
    }
  }, [search, options]);

  const handleSelect = (item) => {
    onChange(item.id); // Just store ID in form
    setSearch(item.email);
    setShowDropdown(false);
  };

  const handleClickOutside = (e) => {
    if (inputRef.current && !inputRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="search-select-container" ref={inputRef}>
      {label && <label className="search-label">{label}</label>}
      <input
        type="text"
        className={`search-input ${errors?.[name] ? "input-error" : ""}`}
        placeholder="Search member email..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onFocus={() => {
          if (search) setShowDropdown(true);
        }}
        autoComplete="off"
      />

      {showDropdown && filtered.length > 0 && (
        <ul className="dropdown-list">
          {filtered.map((item) => (
            <li
              key={item.id}
              onClick={() => handleSelect(item)}
              className="dropdown-item"
            >
              <span>{item.email}</span>
            </li>
          ))}
        </ul>
      )}

      {errors && errors[name] && (
        <p className="text-tiny text-danger pl-3 mt-1">
          {errortext ? errortext : errors[name].message}
        </p>
      )}
    </div>
  );
};

export default MemberSearchSelect;
